import { StatesStore } from "./types";

export const defaultState: StatesStore = {
  states: [],
  loading: false,
};

export const statesArray = [
  {
    countryFull: "United States",
    country: "US",
    stateFull: "Alabama",
    state: "AL",
  },
  {
    countryFull: "United States",
    country: "US",
    stateFull: "Alaska",
    state: "AK",
  },
  {
    countryFull: "United States",
    country: "US",
    stateFull: "Arizona",
    state: "AZ",
  },
  {
    countryFull: "United States",
    country: "US",
    stateFull: "Arkansas",
    state: "AR",
  },
  {
    countryFull: "United States",
    country: "US",
    stateFull: "California",
    state: "CA",
  },
  {
    countryFull: "United States",
    country: "US",
    stateFull: "Colorado",
    state: "CO",
  },
  {
    countryFull: "United States",
    country: "US",
    stateFull: "Connecticut",
    state: "CT",
  },
  {
    countryFull: "United States",
    country: "US",
    stateFull: "Delaware",
    state: "DE",
  },
  {
    countryFull: "United States",
    country: "US",
    stateFull: "District of Columbia",
    state: "DC",
  },
  {
    countryFull: "United States",
    country: "US",
    stateFull: "Florida",
    state: "FL",
  },
  {
    countryFull: "United States",
    country: "US",
    stateFull: "Georgia",
    state: "GA",
  },
  {
    countryFull: "United States",
    country: "US",
    stateFull: "Hawaii",
    state: "HI",
  },
  {
    countryFull: "United States",
    country: "US",
    stateFull: "Idaho",
    state: "ID",
  },
  {
    countryFull: "United States",
    country: "US",
    stateFull: "Illinois",
    state: "IL",
  },
  {
    countryFull: "United States",
    country: "US",
    stateFull: "Indiana",
    state: "IN",
  },
  {
    countryFull: "United States",
    country: "US",
    stateFull: "Iowa",
    state: "IA",
  },
  {
    countryFull: "United States",
    country: "US",
    stateFull: "Kansas",
    state: "KS",
  },
  {
    countryFull: "United States",
    country: "US",
    stateFull: "Kentucky",
    state: "KY",
  },
  {
    countryFull: "United States",
    country: "US",
    stateFull: "Louisiana",
    state: "LA",
  },
  {
    countryFull: "United States",
    country: "US",
    stateFull: "Maine",
    state: "ME",
  },
  {
    countryFull: "United States",
    country: "US",
    stateFull: "Maryland",
    state: "MD",
  },
  {
    countryFull: "United States",
    country: "US",
    stateFull: "Massachusetts",
    state: "MA",
  },
  {
    countryFull: "United States",
    country: "US",
    stateFull: "Michigan",
    state: "MI",
  },
  {
    countryFull: "United States",
    country: "US",
    stateFull: "Minnesota",
    state: "MN",
  },
  {
    countryFull: "United States",
    country: "US",
    stateFull: "Mississippi",
    state: "MS",
  },
  {
    countryFull: "United States",
    country: "US",
    stateFull: "Missouri",
    state: "MO",
  },
  {
    countryFull: "United States",
    country: "US",
    stateFull: "Montana",
    state: "MT",
  },
  {
    countryFull: "United States",
    country: "US",
    stateFull: "Nebraska",
    state: "NE",
  },
  {
    countryFull: "United States",
    country: "US",
    stateFull: "Nevada",
    state: "NV",
  },
  {
    countryFull: "United States",
    country: "US",
    stateFull: "New Hampshire",
    state: "NH",
  },
  {
    countryFull: "United States",
    country: "US",
    stateFull: "New Jersey",
    state: "NJ",
  },
  {
    countryFull: "United States",
    country: "US",
    stateFull: "New Mexico",
    state: "NM",
  },
  {
    countryFull: "United States",
    country: "US",
    stateFull: "New York",
    state: "NY",
  },
  {
    countryFull: "United States",
    country: "US",
    stateFull: "North Carolina",
    state: "NC",
  },
  {
    countryFull: "United States",
    country: "US",
    stateFull: "North Dakota",
    state: "ND",
  },
  {
    countryFull: "United States",
    country: "US",
    stateFull: "Ohio",
    state: "OH",
  },
  {
    countryFull: "United States",
    country: "US",
    stateFull: "Oklahoma",
    state: "OK",
  },
  {
    countryFull: "United States",
    country: "US",
    stateFull: "Oregon",
    state: "OR",
  },
  {
    countryFull: "United States",
    country: "US",
    stateFull: "Pennsylvania",
    state: "PA",
  },
  {
    countryFull: "United States",
    country: "US",
    stateFull: "Rhode Island",
    state: "RI",
  },
  {
    countryFull: "United States",
    country: "US",
    stateFull: "South Carolina",
    state: "SC",
  },
  {
    countryFull: "United States",
    country: "US",
    stateFull: "South Dakota",
    state: "SD",
  },
  {
    countryFull: "United States",
    country: "US",
    stateFull: "Tennessee",
    state: "TN",
  },
  {
    countryFull: "United States",
    country: "US",
    stateFull: "Texas",
    state: "TX",
  },
  {
    countryFull: "United States",
    country: "US",
    stateFull: "Utah",
    state: "UT",
  },
  {
    countryFull: "United States",
    country: "US",
    stateFull: "Vermont",
    state: "VT",
  },
  {
    countryFull: "United States",
    country: "US",
    stateFull: "Virginia",
    state: "VA",
  },
  {
    countryFull: "United States",
    country: "US",
    stateFull: "Washington",
    state: "WA",
  },
  {
    countryFull: "United States",
    country: "US",
    stateFull: "West Virginia",
    state: "WV",
  },
  {
    countryFull: "United States",
    country: "US",
    stateFull: "Wisconsin",
    state: "WI",
  },
  {
    countryFull: "United States",
    country: "US",
    stateFull: "Wyoming",
    state: "WY",
  },
  {
    countryFull: "Canada",
    country: "CA",
    stateFull: "Alberta",
    state: "AB",
  },
  {
    countryFull: "Canada",
    country: "CA",
    stateFull: "British Columbia",
    state: "BC",
  },
  {
    countryFull: "Canada",
    country: "CA",
    stateFull: "Manitoba",
    state: "MB",
  },
  {
    countryFull: "Canada",
    country: "CA",
    stateFull: "New Brunswick",
    state: "NB",
  },
  {
    countryFull: "Canada",
    country: "CA",
    stateFull: "Newfoundland and Labrador",
    state: "NL",
  },
  {
    countryFull: "Canada",
    country: "CA",
    stateFull: "Northwest Territories",
    state: "NT",
  },
  {
    countryFull: "Canada",
    country: "CA",
    stateFull: "Nova Scotia",
    state: "NS",
  },
  {
    countryFull: "Canada",
    country: "CA",
    stateFull: "Nunavut",
    state: "NU",
  },
  {
    countryFull: "Canada",
    country: "CA",
    stateFull: "Ontario",
    state: "ON",
  },
  {
    countryFull: "Canada",
    country: "CA",
    stateFull: "Prince Edward Island",
    state: "PE",
  },
  {
    countryFull: "Canada",
    country: "CA",
    stateFull: "Québec",
    state: "QC",
  },
  {
    countryFull: "Canada",
    country: "CA",
    stateFull: "Saskatchewan",
    state: "SK",
  },
  {
    countryFull: "Canada",
    country: "CA",
    stateFull: "Yukon",
    state: "YT",
  },
];
